var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationMailbox = function SvgSimpleIllustrationMailbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__mailbox_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__mailbox_svg__st3{fill:#d18000}.simple-illustration__mailbox_svg__st5{fill:#0185ff}.simple-illustration__mailbox_svg__st6{fill:#f25730}.simple-illustration__mailbox_svg__st7{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27.1v11h-3.7v-9.6c0-.9.4-1.4 1.4-1.4h2.3z",
    style: {
      fill: "#fffaf0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 24.7v13.4h-4.5V26.3c0-.9.5-1.6 1.5-1.6h3z",
    style: {
      fill: "#ffed8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 22.7v2H26c-1.1 0-1.5.7-1.5 1.6v.8h-2.3c-1 0-1.4.5-1.4 1.4v9.6h-2.7V24.5c0-1.5.7-2.4 2.4-2.4h8.4v.6z",
    style: {
      fill: "#e4bc07"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 40.7v22.8c0 1.3-.3 2-1.9 1.9h-2.6V40.7H43zM38.5 40.7v24.7h-1.2c-1.6 0-1.9-.7-1.9-1.9V40.7h3.1z",
    className: "simple-illustration__mailbox_svg__st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 22.1h-8.4c-1.7 0-2.4.9-2.4 2.4v13.6h-2.8V22.7c0-4.1 3.4-6.1 6.8-6.1s6.5 1.8 6.8 5.5z",
    style: {
      fill: "#0164bf"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 38.1v2.6H8.1c-2 0-2-2.6 0-2.6h20.8z",
    className: "simple-illustration__mailbox_svg__st5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 22.1c-.3-3.7-3.5-5.5-6.8-5.5h12.7V31c0 .8.4 1.3 1.3 1.3h3.3c.9 0 1.5-.5 1.5-1.4V28c0-.9-.5-1.5-1.5-1.5h-1.9v-10h13.9c3.3.1 6.6 2.1 6.6 6.1v18H28.9V22.1z",
    className: "simple-illustration__mailbox_svg__st5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7 30.7c.6 0 1.2-.5 1.2-1.2 0-.6-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2c.1.7.6 1.2 1.2 1.2z",
    className: "simple-illustration__mailbox_svg__st6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 9.8v1.5c0 1.1-.5 1.8-1.8 1.8h-3.2c-1.1 0-1.6.6-1.6 1.6v12h1.9c.9 0 1.4.6 1.5 1.5V31c0 .9-.5 1.4-1.5 1.4h-3.3c-.9 0-1.3-.5-1.3-1.3V10.6c0-1.5.9-2.6 2.6-2.6h4.9c1.1 0 1.8.6 1.8 1.8zm-5.2 19.8c0-.6-.5-1.2-1.2-1.2-.6 0-1.2.5-1.2 1.2 0 .6.5 1.2 1.2 1.2.7-.1 1.2-.6 1.2-1.2z",
    className: "simple-illustration__mailbox_svg__st6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40.7H8.1M28.9 38.1H8.1M8.1 38.1c-2 0-2 2.6 0 2.6M28.9 40.7v-18M15.3 38.1V22.7M28.9 22.7v-.6c-.3-3.7-3.5-5.5-6.8-5.5-3.4 0-6.8 2-6.8 6.1M58 40.7v-18M58 22.7c0-4-3.3-6-6.6-6.1M34.8 16.6H22.1M51.4 16.6H37.5M24.5 26.3v11.8M20.8 28.5v9.6M24.5 26.3c0-.9.5-1.6 1.5-1.6M20.8 28.5c0-.9.4-1.4 1.4-1.4M18.1 38.1V24.5M26 24.7h2.9M22.2 27.1h2.3",
    className: "simple-illustration__mailbox_svg__st7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 24.5c0-1.5.7-2.4 2.4-2.4M35.3 40.7v22.8M20.5 22.1h8.4M34.8 31V10.6M37.5 26.6v-12M35.3 63.5c0 1.3.3 2 1.9 1.9M43 40.7v22.8M43 63.5c0 1.3-.3 2-1.9 1.9M37.3 65.4h3.8M38.5 40.7v24.7M34.8 10.6c0-1.5.9-2.6 2.6-2.6M37.5 14.7c0-1 .5-1.6 1.6-1.6M36.1 32.4h3.3M40.8 31v-2.8M39.4 26.6h-1.9M39.4 26.6c.9 0 1.4.6 1.5 1.5M39.4 32.4c.9 0 1.5-.5 1.5-1.4M36.1 32.4c-.9 0-1.3-.5-1.3-1.3M39.1 13.1h3.2M37.4 8h4.9M42.3 13.1c1.3 0 1.8-.7 1.8-1.8M42.3 8c1.1 0 1.8.6 1.8 1.8M44.1 11.3V9.8M37.7 30.7c.6 0 1.2-.5 1.2-1.2 0-.6-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2c.1.7.6 1.2 1.2 1.2z",
    className: "simple-illustration__mailbox_svg__st7"
  })));
};
export default SvgSimpleIllustrationMailbox;